<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">物流&订单管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">出库管理</div>
    </div>

    <div class="main_content">
      <div class="tit">订单发货方法处理设置</div>
      <div class="block">
        <h1><span class="mark">*</span>订单发货处理方法</h1>
        <div class="radio_box">
          <van-radio-group
            direction="horizontal"
            v-model="formData.sendtype"
            style="justify-content: space-evenly"
          >
            <van-radio name="待定">待定</van-radio>
            <van-radio name="订单整单发货">订单整单发货</van-radio>
            <van-radio name="拆分发货（一件代发）"
              >拆分发货（一件代发）</van-radio
            >
          </van-radio-group>
        </div>
      </div>
      <div class="block">
        <h1><span class="mark">*</span>订单所属区域：</h1>
        <p>{{ formData.inarea }}</p>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>

    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import { wlserviceedit, getLogisticsDetail } from "../../api/shop";
export default {
  name: "outboundLogisticsEdit",
  data() {
    return {
      loading: false,
      columns: [],
      formData: {
        id: "",
        orderno: "",
        qyguid: "",
        sendtype: "",
        inarea: "",
      },
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;

    this.formData.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getLogisticsDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getLogisticsDetail(id) {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getLogisticsDetail({ id }).then((res) => {
        this.formData.orderno = res.orderno ? res.orderno : "";
        this.formData.sendtype = res.sendtype ? res.sendtype : "待定";
        this.formData.inarea = res.inarea ? res.inarea : "";
        toast.clear();
      });
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.sendtype == "") {
        this.$toast("请选择订单发货处理方法");
        return;
      }
      if (formData.inarea == "") {
        this.$toast("请选择订单所属区域");
        return;
      }
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      wlserviceedit(formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .warehouse {
        width: 560px;
        margin: auto;
        text-align: left;
      }
    }
  }
}
</style>